import React from 'react';
import {Link} from 'react-router'
import AppContainer from './app-container';
import TimeTicker from '../components/time-ticker';
import ImageSwitcher from '../components/image-switcher';
import * as partnerActions from '../actions/partners';
import * as postActions from '../actions/post';
import * as stageActions from '../actions/stages';
import Loading from '../components/loading';
import moment from 'moment';
import DocumentTitle from 'react-document-title';
import classnames from 'classnames';

import PostsList from '../components/post/posts-list';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import LocalizedStrings from '../localization/strings';
import PartnersDisplay from '../components/partner/partners-display';
import StagesTable from '../components/stages-table';

const displayNews = window.CARE_CONFIG.settings.display_news;
const displayPartners = window.CARE_CONFIG.settings.display_partners;
const multipleStages = window.CARE_CONFIG.settings.multiple_stage_display;

class HomeContainer extends AppContainer {

    componentDidMount() {
        if (displayPartners) {
            this.props.actions.fetchAllPartners();
        }
        this.props.actions.fetchUpcomingStage();
        this.props.actions.fetchRegistratioToAll();
        this.props.actions.fetchRegistratioToCustom();

        if (displayNews) {
            this.props.actions.fetchPostsPaginated(0, 5);
        }

    }

    renderStageActions(stage) {
        if (stage.external_website_registration) {
            return (
                <div className="actions-row">
                    <a className="btn btn-main-color"
                       href={stage.external_registration_link}>{LocalizedStrings.register}</a>
                    {stage.live_results ?
                      <a className="btn btn-main-color"
                         href={stage.live_results}>{LocalizedStrings.liveResults}</a> : null
                    }
                    <a className="btn btn-main-color"
                       href={stage.external_regulations_link}>{LocalizedStrings.regulations}</a>
                </div>
            )
        }
        return (
            <div className="actions-row">
                {stage.registration_enabled
                    ? <Link className="btn btn-main-color" to={`/stages/${stage.id}/registration`}>
                        {LocalizedStrings.register}
                    </Link> : null}
                {stage.live_results ?
                    <a className="btn btn-main-color"
                        href={stage.live_results}>{LocalizedStrings.liveResults}</a> : null
                }
                <Link className="btn btn-main-color" to={`/stages/${stage.id}/regulations`}>
                    {LocalizedStrings.regulations}
                </Link>
            </div>
        )

    }

    renderRegisterToAll(){
        if(this.props.registerToAllStages && this.props.registerToAllStages.id){
            return <div className="actions-row">
                <Link className="btn btn-main-color"
                      to={`/stages/${this.props.registerToAllStages.id}/registration`}>
                    {LocalizedStrings.registerToAllStages}
                </Link>
            </div>
        }
        return null;

    }

    renderRegisterToCustom(){
        if(this.props.registerToCustomStages && this.props.registerToCustomStages.stages && this.props.registerToCustomStages.stages.length){
            return <div className="actions-row">
                {this.props.registerToCustomStages.stages.map(stage =>
                    <Link className="btn btn-main-color"
                          to={`/stages/${stage.id}/registration`} key={stage.id}>
                        {stage.name}
                    </Link>
                )}
            </div>
        }
        return null;

    }


    renderStageInfo(stage){
        return (
            <div className="stage">
                <div className="time-display">{moment(stage.stage_date).format('YYYY-MM-DD')}</div>
                <h2 className="title">{stage.name}</h2>
                <div className="time-left">
                    <TimeTicker date={new Date(stage.stage_date)}></TimeTicker>
                </div>
                {this.renderStageActions(stage)}
            </div>
        )
    }


    renderStageWithActions(stage) {
        if (!stage || Object.keys(stage).length === 0) {
            return (
                <div className="welcome-text">
                    <h2 className="title">{LocalizedStrings.noUpcommingStages}</h2>
                    {this.renderRegisterToAll()}
                    {this.renderRegisterToCustom()}

                </div>
            )
        }
        return (
            <div className="welcome-text">
                {this.renderStageInfo(stage)}
                {this.renderRegisterToAll()}
                {this.renderRegisterToCustom()}

            </div>
        )
    }

    hasManyStages(){
        const {upcomingStage} = this.props;
        if(upcomingStage.loading || !upcomingStage.item.stages){
            return false;
        }
        if(multipleStages && upcomingStage.item.stages.length > 2){
            return true
        }
        return false;
    }

    renderStages(){
        const {upcomingStage} = this.props;
        if(upcomingStage.loading || !upcomingStage.item.stages){
            return (<div className="welcome-text"><Loading/></div>);
        }

        const upcommingStage = upcomingStage.item.stages.length ? upcomingStage.item.stages[0]: null;
        if(!multipleStages){
            return this.renderStageWithActions(upcommingStage);
        }

        if(upcomingStage.item.stages.length > 2){
            return <div className="stages-table"><StagesTable stages={{
            items: upcomingStage.item.stages, loading: false
            }}/></div>
        }
        else return <div className="multiple-stages">{
            upcomingStage.item.stages.map((stage)=>{
                return this.renderStageInfo(stage)
            })
        }</div>
    }

    render() {
        return (
            <DocumentTitle title={this.getDocumentTitle()}>

                <div className="home">
                    <div id="welcome-page" className="welcome-page">
                        <div className={classnames('welcome-images', this.hasManyStages() && 'with-many-stages')}>
                            <ImageSwitcher images={window.CARE_CONFIG.landingImages}></ImageSwitcher>
                        </div>

                        {this.renderStages()}



                    </div>
                    {displayNews && (
                        <div id="about" className="page-section">
                            <div className="container">
                                <h3 className="title">
                                    <span>{LocalizedStrings.news}</span>
                                </h3>
                                <div>
                                    {this.props.posts.loading
                                        ? <Loading/>
                                        : <PostsList posts={this.props.posts.items}></PostsList>}
                                </div>
                            </div>
                        </div>
                    )}
                    {displayPartners && (
                        <div className="page-section grey">
                            <div className="container">
                                <h3 className="title">
                                    <span>{LocalizedStrings.partners}</span>
                                </h3>
                                {this.props.partners.loading
                                    ? <Loading/>
                                    : (
                                        <PartnersDisplay partners={this.props.partners.items}/>

                                    )
                                }

                            </div>
                        </div>
                    )}

                </div>
            </DocumentTitle>
        )
    }
}

export default connect(function (state) {
    return {
        partners: state.partner.partners,
        posts: state.post.posts,
        upcomingStage: state.stage.upcomingStage,
        registerToAllStages: state.stage.registerToAllStages.item || null,
        registerToCustomStages: state.stage.registerToCustomStages.item || null
    };
}, function (dispatch) {
    return {
        actions: bindActionCreators({
            ...partnerActions,
            ...postActions,
            ...stageActions
        }, dispatch)
    };
})(HomeContainer);



// WEBPACK FOOTER //
// ./src/js/containers/home-container.js